import { Fragment } from 'react';
import { Menu } from '@pocketlaw/tetris';
const isGroupNode = (node) => node.kind === 'group';
const isLeafGroup = (node) => node.children.every((child) => !isGroupNode(child));
const hasLeafDescendants = (node) => node.children.some((child) => !isGroupNode(child) || hasLeafDescendants(child));
/**
 * Component to recursively walk over the node tree and render menu items.
 */
export function SearchableMenuGroupedItems(props) {
    const { nodes, depth = 0, flat = false, path = [], render, excludeIds = [] } = props;
    /**
     * In flat mode, items in `excludeIds` are already rendered outside this component (e.g. as selected items),
     * so we hide them here to avoid duplication.
     *
     * In nested mode we keep all nodes visible, since filtering them out could leave group headers with no
     * children, which would be both broken and confusing.
     */
    const visibleNodes = excludeIds.length && flat ? nodes.filter((node) => !excludeIds.includes(node.id)) : nodes;
    return visibleNodes.map((node) => {
        if (!isGroupNode(node)) {
            return render(node);
        }
        if (!hasLeafDescendants(node)) {
            return null;
        }
        if (flat) {
            const hasDirectFilters = node.children.some((child) => !isGroupNode(child));
            const currentPath = [...path, node.name];
            return (<Fragment key={node.id}>
          {hasDirectFilters && <Menu.Label>{currentPath.join(' / ')}</Menu.Label>}
          <SearchableMenuGroupedItems nodes={node.children} depth={depth + 1} flat path={currentPath} render={render} excludeIds={excludeIds}/>
        </Fragment>);
        }
        if (depth > 0 && isLeafGroup(node)) {
            return (<Fragment key={node.id}>
          <Menu.Label>{node.name}</Menu.Label>
          <SearchableMenuGroupedItems nodes={node.children} depth={depth + 1} render={render} excludeIds={excludeIds}/>
        </Fragment>);
        }
        return (<Menu.ItemNested key={node.id} target={node.name}>
        <SearchableMenuGroupedItems nodes={node.children} depth={depth + 1} render={render} excludeIds={excludeIds}/>
      </Menu.ItemNested>);
    });
}
